export const english = {
  location_filter_text: "Select location(s)",
  discipline_filter_text: "Select discipline(s)",
  level_filter_text: "Select level(s)",
  age_filter_text: "Select age(s)",
  season_filter_text: "Select season(s)"
};
